<template>
    <dropdown class="captive-forms-list-item-actions"
              :data-border="false"
              dataMenuWidth="115px"
              data-icon="mdi-dots-vertical"
              @hidden="hideEveryModal">
          
      <p class="captive-forms-list-item-actions-item pointer"
         @click.stop="showEditModal">
        {{$t('message.generics.message.edit')}}
      </p>
  
      <p :class="{'disabled': isSocialLogin}"
         class="captive-forms-list-item-actions-item pointer"
         @click.stop="showDeleteModal">
        {{$t('message.generics.message.delete')}}
      </p>
  
      <confirmation-modal :value="showingCaptiveFormDeleteModal"
                          :confirm-label="$t('message.generics.message.confirm')"
                          @confirm="deleteCaptiveForm"
                          @cancel="closeDeleteModal">
        <span slot="heading">
          {{$t('message.loginPersonalize.message.deleteForm')}}
        </span>
        <span>
          {{$t('message.loginPersonalize.message.deleteFormConfirmation')}}
        </span>
      </confirmation-modal>
         
      <captive-forms-modal :manual-show.sync="showingEditModal"
                            no-activator
                            :item="item" 
                            @edited="emitEdited"/>
    </dropdown>
  </template>
  
  <script>  
  import CaptiveFormsModal from "@components/modules/captive-forms/modal/CaptiveFormsModal.vue";
  import ConfirmationModal from "@components/ConfirmationModal";
  import Dropdown from "@components/Dropdown";
  import EventBus from "@packages/event-bus";
  
  export default {
    components: {
      Dropdown,
      ConfirmationModal,
      CaptiveFormsModal      
    },
    data() {
      return {        
        showingEditModal: false,
        showingCaptiveFormDeleteModal: false
      };
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
  
    computed: {
      isSocialLogin() {
        return this.item.type === "FACEBOOK" || this.item.type === "TWITTER" || this.item.type === "LINKEDIN" ? true : false
      }
    },
    methods: {
    
      showEditModal() {
        this.showingEditModal = true;
      },
      hideEveryModal() {
        this.closeDeleteModal();
      },
      showDeleteModal() {
        this.showingCaptiveFormDeleteModal = true;
      },
      closeDeleteModal() {
        this.showingCaptiveFormDeleteModal = false;
      },
      async deleteCaptiveForm() {
        try {
          EventBus.$emit("SHOW_SPINNER");
  
          await this.$api.core.loginTypes.delete({
            id: this.item.id           
          });
  
          EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: this.$t('message.successMessages.message.formDeleted'),
          });
  
          this.closeDeleteModal();
  
          this.$emit("deleted");
        } catch (error) {
          // empty
        } finally {
          EventBus.$emit("CANCEL_SPINNER");
        }
      },              
      emitEdited() {
        this.$emit("edited");
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .captive-forms-list-item-actions {

    .disabled {
      pointer-events: none;
      font-weight: 400 !important;
    }

    ::v-deep .dropdown-menu {
      right: 92%;
    }

    .captive-forms-list-item-actions-item {
      margin-bottom: 0px;
      font-size: 12px;
      color: #707070;
      font-weight: 600;
      margin-bottom: 5px;      
  
      &:hover {
        transform: translateY(-1px);
      }
  
      &:active {
        box-shadow: none;
        transform: translateY(1px);
      }
  
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  </style>
  